<div class="modal_content flex flex-col gap-6 w-screen max-w-[30rem] p-6">
  <div class="flex items-center justify-between">
    <div class="text-2xl font-medium">{{ 'MODALS.COMPLAIN.TITLE' | transloco }}</div>
    <app-ui-button
      class="style-ghost max-xsm:hidden"
      (buttonClick)="cancelForm()"
    >
      <i class="ph ph-x text-2xl/6"></i>
    </app-ui-button>
  </div>

  <form [formGroup]="complainForm">
    <div class="relative">
      <!-- Группа чекбоксов без видимой легенды -->
      <div
        class="max-xsm:hidden"
        libScrollbar
        scrollbarPosition="inside"
      >
        <div class="grid max-h-[14.8rem] gap-4 grid-cols-2">
          @for (item of checkboxItems(); track item.id) {
            <app-ui-checkbox
              [attr.aria-describedby]="'checkbox-desc-' + item.id"
              [label]="item.label | transloco"
              [disabled]="checkboxCount() > 4 && !complainForm.controls[item.id].value"
              (checkboxChanged)="setCheckboxValue(item.id, $event)"
            />
          }
        </div>
      </div>
      <div
        class="xsm:hidden"
        libScrollbar
        scrollbarPosition="inside"
        scrollVisibility="always-show"
      >
        <div class="grid max-h-[14.8rem] grid-cols-1 gap-4 xsm:grid-cols-2">
          @for (item of checkboxItems(); track item.id) {
            <app-ui-checkbox
              [attr.aria-describedby]="'checkbox-desc-' + item.id"
              [label]="item.label | transloco"
              [disabled]="checkboxCount() > 4 && !complainForm.controls[item.id].value"
              (checkboxChanged)="setCheckboxValue(item.id, $event)"
            />
          }
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2 pt-6 relative">
      @let charCount = complainForm.controls.details.value.length || 0;

      <div class="flex items-center justify-between">
        <div class="dark:text-grey-100 text-base font-normal">
          {{ 'MODALS.TELL_US_MORE.ADDITIONAL_DETAILS' | transloco }}
        </div>
        <span class="dark:text-grey-250 text-xs">
          <span [class.text-red-400]="charCount > descriptionMaxLength"> {{ charCount }} </span>/ {{ descriptionMaxLength }}
        </span>
      </div>

      <!-- Поле для дополнительных деталей -->
      <app-ui-editable-div
        formControlName="details"
        [placeholder]="'MODALS.COMPLAIN.DETAILS_PLACEHOLDER' | transloco"
      />

      @if (charCount > descriptionMaxLength) {
        <span class="absolute -bottom-[1.125rem] font-normal text-red-500 text-xs">
          {{ 'COMMON.ERRORS.MAX_LENGTH' | transloco: { length: descriptionMaxLength } }}
        </span>
      }
    </div>
  </form>
  <!-- Кнопки управления -->
  <div class="modal_content_btns flex w-full flex-col gap-3 xsm:flex-row xsm:gap-6">
    <app-ui-button
      aria-label="Cancel"
      class="style_secondary size_xl"
      (buttonClick)="cancelForm()"
    >
      {{ 'COMMON.CANCEL' | transloco }}
    </app-ui-button>

    <app-ui-button
      aria-label="Submit complaint"
      class="style_primary size_xl"
      [disabled]="isFormEmpty() || complainForm.invalid || isSubmitting()"
      (buttonClick)="submitForm()"
    >
      {{ 'COMMON.SUBMIT' | transloco }}
    </app-ui-button>
  </div>
</div>
